<div class="dialog-info-service-unavailable">
    <p>Sprawdź możliwe <a target="_blank" [href]="helpUrl">powody niedostępności</a> usługi lub skontaktuj się z <a [href]="'mailto:' + mailto" >BOK</a>, by uzyskać więcej informacji.</p>
</div>
